import React from 'react';

import LBCon from "./../../../../Components/M23/Withdrawal/LB";

import Item from "./../../../Common/FormItem";
import Input from "./../../../Common/Input";
import WithdrawalMoney from "./../../../Common/WithdrawalMoney";
import BankAccount from "./../../../Common/BankAccount";
import MemberBanks from "./../../../Common/MemberBanks";
import WithdrawalSuccessTimer from "./../../../Common/WithdrawalSuccessTimer";

import translate from "./../../../../lib/translate/TranslateJs";
import { PendingWithdraw, ThresholdWithdraw, WithdrawKycModal } from './../../../Component/WithdrawModal'

function LB(props) {
    return (
        <div className="LB-container">
            <LBCon
                {...props}
                Item={(props) => (
                    <Item
                        className=""
                        {...props}
                    />
                )}
                Input={Input}
                PendingWithdraw={PendingWithdraw}
                WithdrawKycModal={WithdrawKycModal}
                ThresholdWithdraw={ThresholdWithdraw}
                WithdrawalSuccessTimer={WithdrawalSuccessTimer}
                WithdrawalMoney={WithdrawalMoney}
                BankAccount={BankAccount}
                MemberBanks={MemberBanks}
                SetDefault={(propCon) => (
                    <div className="defaultBox" onClick={propCon.onClick}>
                        <div className={`checkIcon ${propCon.value === 1 ? "checked" : ""}`}></div>
                        <p>{translate("设置为默认银行")()}</p>
                    </div>
                )}
                SubmitBtn={(propCon) => (
                    <button
                        className={`primary-button ${propCon.disabled && 'disabled'}`}
                        disabled={propCon.disabled}
                        onClick={(e)=>{
                            // 避免同時觸發onClick and Form的onFinish
                            e.preventDefault();
                            propCon.onClick()
                        }}
                    >
                        {translate("提交")()}
                    </button>
                )}
            />
        </div>
    );
}


export default LB;

